import React, { useState } from "react";
import { getOfferCapabilities } from "../../../common/offerCapabilities";
import { PackageUpgradeModal } from "./OfferGate";
import { Box, Button, CheckBox, Heading, Text } from "grommet";
import LocalizedTextEditor, { SMS_MAX_LENGTH } from "./LocalizedTextEditor";
import { useTranslation } from "react-i18next";

export default function CheckinFlowPostCheckin({
  formValues,
  onChange,
  communications,
  onCommunicationsChange,
  onSaveCommunications,
  savedCommunications,
  defaults,
  hotel,
}) {
  const { t } = useTranslation();
  const [upgrade, setUpgrade] = useState(false);
  const messaging = getOfferCapabilities(hotel).messaging;

  const handleToggle = (name) => (e) => {
    if (!messaging) { setUpgrade(true); return; }
    onChange({ ...formValues, [name]: e.target.checked });
  };

  return (
    <Box id="section-postcheckin" gap="medium">
      {upgrade && <PackageUpgradeModal capability="messaging" onClose={() => setUpgrade(false)} />}
      <Heading level={3} margin="none">
        {t("checkinFlow.postCheckin.title")}
      </Heading>
      <Text size="small" color="dark-4">
        {t("checkinFlow.postCheckin.description")}
      </Text>

      <Box gap="small">
        <CheckBox
          checked={messaging && !!formValues.postCheckinMessageEnabled}
          onChange={handleToggle("postCheckinMessageEnabled")}
          label={t("checkinFlow.postCheckin.toggle")}
          toggle
        />
        {messaging && formValues.postCheckinMessageEnabled && (
          <Box
            pad={{ left: "medium" }}
            border={{ side: "left", color: "light-4", size: "2px" }}
          >
            <LocalizedTextEditor
              value={
                communications?.postCheckinText || defaults?.postCheckinText
              }
              onChange={(val) =>
                onCommunicationsChange({
                  ...communications,
                  postCheckinText: val,
                })
              }
              defaultValue={defaults?.postCheckinText}
              useCustom={!!communications?.useCustomPostCheckinText}
              onUseCustomChange={(v) => {
                const updated = {
                  ...communications,
                  useCustomPostCheckinText: v,
                };
                onSaveCommunications(updated);
              }}
              hint={t("checkinFlow.common.hintTagsWithChatLink")}
              maxLength={SMS_MAX_LENGTH}
              showChatLink
              tags={[
                "firstName",
                "lastName",
                "checkinDate",
                "checkinTime",
                "checkoutDate",
                "checkoutTime",
              ]}
            />

            {!!communications?.useCustomPostCheckinText && (
              <>
                <Box gap="xsmall">
                  {!(
                    communications?.postCheckinText?.en ??
                    defaults?.postCheckinText?.en
                  )?.trim() && (
                    <Text size="small" color="status-critical">
                      {t("checkinFlow.common.textMissing")}
                    </Text>
                  )}
                  {hotel?.language === "fr" &&
                    !(
                      communications?.postCheckinText?.fr ??
                      defaults?.postCheckinText?.fr
                    )?.trim() && (
                      <Text size="small" color="status-warning">
                        {t("checkinFlow.common.frTextMissing")}
                      </Text>
                    )}
                </Box>
                <Box align="end" gap="xsmall">
                  <Text size="xsmall" color="dark-4">
                    {t("checkinFlow.common.pressTextSave")}
                  </Text>
                  <Button
                    label={t("checkinFlow.common.save")}
                    primary
                    size="small"
                    disabled={
                      JSON.stringify(communications?.postCheckinText) ===
                        JSON.stringify(savedCommunications?.postCheckinText) ||
                      (communications?.postCheckinText?.en || "").length >
                        SMS_MAX_LENGTH ||
                      (communications?.postCheckinText?.fr || "").length >
                        SMS_MAX_LENGTH
                    }
                    onClick={() => onSaveCommunications()}
                  />
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}
